// src/components/Navbar.jsx
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const links = [
  { path: "/", label: "Home", icon: "🏡" },
  { path: "/pantry", label: "Pantry", icon: "🥫" },
  { path: "/recipes", label: "Recipes", icon: "📖" },
  { path: "/grocery", label: "Grocery", icon: "🛒" },
  { path: "/community", label: "Community", icon: "🌍" },
  { path: "/stores", label: "Stores", icon: "📍" },
];

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav style={styles.nav}>
      <div style={styles.inner}>
        <Link to="/" style={styles.logo}>
          <img src="/myicon.png" className="logoImg" />
          CaféPantry
        </Link>

        {/* Desktop links */}
        <div style={styles.links}>
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              style={{
                ...styles.link,
                ...(location.pathname === l.path ? styles.activeLink : {}),
              }}
            >
              <span style={{ marginRight: "5px" }}>{l.icon}</span>
              {l.label}
            </Link>
          ))}
        </div>

        {/* Hamburger */}
        <button style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={styles.mobileMenu}>
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              style={{
                ...styles.mobileLink,
                ...(location.pathname === l.path ? styles.activeMobile : {}),
              }}
              onClick={() => setMenuOpen(false)}
            >
              {l.icon} {l.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}

const styles = {
  nav: {
    background: "#fff9f2",
    borderBottom: "1.5px solid #e0cdb0",
    position: "sticky",
    top: 0,
    zIndex: 100,
    boxShadow: "0 2px 12px rgba(107,79,46,0.08)",
  },
  inner: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 1.5rem",
    height: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logo: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#6b4f2e",
    letterSpacing: "-0.01em",
  },
  links: {
    display: "flex",
    gap: "0.25rem",
    alignItems: "center",
    flexWrap: "wrap",
  },
  link: {
    padding: "0.4rem 0.85rem",
    borderRadius: "50px",
    fontSize: "0.88rem",
    fontWeight: 700,
    color: "#9b7b54",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
  },
  activeLink: {
    background: "#f0e8d8",
    color: "#6b4f2e",
  },
  hamburger: {
    display: "none",
    background: "none",
    border: "none",
    fontSize: "1.4rem",
    color: "#6b4f2e",
    cursor: "pointer",
  },
  mobileMenu: {
    display: "flex",
    flexDirection: "column",
    background: "#fff9f2",
    borderTop: "1px solid #e0cdb0",
    padding: "0.75rem 1.5rem 1rem",
    gap: "0.5rem",
  },
  mobileLink: {
    padding: "0.6rem 0.75rem",
    borderRadius: "8px",
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#9b7b54",
  },
  activeMobile: {
    background: "#f0e8d8",
    color: "#6b4f2e",
  },
};

// Responsive hamburger visibility via media query hack
if (typeof window !== "undefined") {
  const style = document.createElement("style");
  style.textContent = `
    @media (max-width: 700px) {
      nav > div:first-child > div { display: none !important; }
      nav > div:first-child > button { display: block !important; }
    }
  `;
  document.head.appendChild(style);
}
